import { useNavigate } from 'react-router-dom';
import { Alert, Button, Card, Form, Result, Space } from 'antd';

import { AccessDependencyDetail, EnsureAccessDto } from '@app/domain-access-interfaces';
import { Axios } from '@app/web-components';

import { AccessSelect } from '../../../common';
import { useEditDependency } from '../data';

type FormData = {
  parent: EnsureAccessDto[];
};

export type AddFormProps = {
  id: number;
  record: AccessDependencyDetail[];
};

export const AddForm = ({ id, record }: AddFormProps) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const addDependency = useEditDependency(id);

  const handleSubmit = (data: FormData) => {
    addDependency.mutate(data);
  };

  if (addDependency.isSuccess) {
    return (
      <Result
        status="success"
        title="Successfully created a dependency!"
        subTitle={`Dependency Id: ${addDependency.data.data.parentId}`}
        extra={[
          <Button type="primary" key="go to access" onClick={() => navigate('../')}>
            Go To Access
          </Button>,
          <Button
            key="create another"
            onClick={() => {
              addDependency.reset();
              form.resetFields();
            }}
          >
            Create Another
          </Button>,
        ]}
      />
    );
  }

  return (
    <Form
      form={form}
      labelCol={{ span: 4 }}
      layout="vertical"
      style={{ width: '100%', minWidth: 1000 }}
      initialValues={{
        parent: record.map((x) => x.parent),
      }}
      disabled={addDependency.isPending || addDependency.isSuccess}
      onFinish={handleSubmit}
    >
      {addDependency.error ? (
        <Form.Item label=" " colon={false} hidden={!addDependency.error}>
          <Alert message="Error" description={Axios.getErrorMessage(addDependency.error)} type="error" showIcon />
        </Form.Item>
      ) : undefined}
      <Card>
        <Form.Item label="Access List" name="parent" rules={[{ required: true, message: 'Access list is required.' }]}>
          <AccessSelect />
        </Form.Item>

        <Space style={{ marginTop: 20 }}>
          <Button type="primary" htmlType="submit" loading={addDependency.isPending}>
            Save
          </Button>
          <Button onClick={() => form.resetFields()}>Reset</Button>
          <Button onClick={() => navigate('../')}>Cancel</Button>
        </Space>
      </Card>
    </Form>
  );
};
